import radioCheckedImage from './radio-checked.svg'
import radioUncheckedImage from './radio-unchecked.svg'

interface Props {
  checked: boolean
  width?: number
  height?: number
}

export function RadioImage({ checked, width, height }: Props) {
  return <img src={checked ? radioCheckedImage : radioUncheckedImage} width={width} height={height} />
}
